import { Edit, Form, Input, TextField, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITrackPurchase } from "types/track.purchase.interface";

export const TrackPurchaseEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<ITrackPurchase>();

  const { queryResult } = useShow<ITrackPurchase>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <TextField
        style={{ fontSize: "14px", fontWeight: "bold" }}
        value={`Max number downloads of this label: ${record?.data?.track?.label?.numberDownloads}`}
      />
      <Form style={{ marginTop: "20px" }} {...formProps} layout="vertical">
        <Form.Item
          label="Number Downloads"
          name="numberDownloads"
          rules={[
            {
              required: true,
              message: "Number Downloads is required",
            },
          ]}
        >
          <Input
            defaultValue={record?.data.type !== "subscription" ? record?.data.numberDownloads : 0}
            type="number"
            max={record?.data?.track?.label?.numberDownloads}
          />
        </Form.Item>

        <Form.Item
          label="User"
          name="user"
          rules={[
            {
              required: false,
              message: "User is required",
            },
          ]}
        >
          <Input defaultValue={record?.data.user.email} disabled />
        </Form.Item>

        <Form.Item
          label="Track"
          name="track"
          rules={[
            {
              required: false,
              message: "Track is required",
            },
          ]}
        >
          <Input defaultValue={record?.data.track.title} disabled />
        </Form.Item>
      </Form>
    </Edit>
  );
};
